import { Avatar } from "@mui/material";
import { Carousel, Progress } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { routingConstants } from "@/Constants/routingConstants";

/**
 * Generate ShiftCalendarPopups with the given data and shiftDate.
 *
 * @param {object} data - the data for rendering the popups
 * @param {string} shiftDate - the date for rendering the popups
 * @return {JSX.Element} the rendered ShiftCalendarPopups component
 */
export const ShiftCalendarPopups = ({ data, shiftDate }) => {
  const { clientUserAllPermissions } = useSelector((state) => state.session);

  /**
   * Function to get the color based on the progress percentage.
   *
   * @param {number} percentage - The progress percentage
   * @return {string} The color code based on the percentage
   */
  const getProgressColor = (percentage) => {
    if (percentage <= 50) {
      return "#ED3A3E";
    } else if (percentage > 51 && percentage < 100) {
      return "#FFC446";
    } else if ((percentage = 100)) {
      return "#5EBB5B";
    }
  };
  /**
   * Calculates the difference in days between the input date and the current date.
   *
   * @param {Date} date - The input date for which the difference is calculated.
   * @return {string} The formatted string indicating the number of days left.
   */
  const getTodayDiff = (date) => {
    const today = moment();
    const diff = moment(shiftDate).diff(today, "days");
    return `${diff + 1} Days left`;
  };
  return (
    <div className="ShiftCalendarPopups_Wrapper min-h-[73px] !w-[220px] pb-2">
      <Carousel autoplay dots={false} autoplaySpeed={2000}>
        {data.map((item, index) => {
          const {
            profile_image,
            candidate_name,
            profile_percent,
            licence_no,
            contract_status,
            role_name,
            main_contract_ref_no,
            main_contract_start_date,
            main_contract_end_date,
            main_contract_created_date,
            route_id,
            route_contract_id,
            is_past_booking,
          } = item;
          if (contract_status == "Published") {
            return (
              <div className="overflow-hidden font-openSans" key={index}>
                <div className="flex max-w-full gap-3 px-[12px] py-[8px]">
                  <div className="flex flex-col gap-[3px]">
                    <h4 className="m-0 line-clamp-1 text-[14px] font-semibold leading-[20px] text-black">
                      {role_name}
                    </h4>
                    {!clientUserAllPermissions ||
                    clientUserAllPermissions.is_allow_to_view_contract_detail ===
                      1 ? (
                      <>
                        <Link
                          to={routingConstants.contractDetail(
                            route_contract_id,
                          )}
                          className="text-[12px] font-medium leading-[normal] text-txtColor"
                          target="_blank"
                        >
                          {main_contract_ref_no}
                        </Link>
                      </>
                    ) : (
                      <span className="cursor-default text-[12px] font-medium leading-[normal] text-txtColor">
                        {main_contract_ref_no}
                      </span>
                    )}
                    {/* <Link to={routingConstants.contractDetail(route_contract_id)} className="text-[12px] text-txtColor font-medium leading-[normal]">
                      {main_contract_ref_no}
                    </Link> */}
                    <span className="text-[12px] font-medium leading-[normal] text-txtColor">
                      {moment(main_contract_start_date, "YYYY-MM-DD").format(
                        "DD/MM/YYYY",
                      )}{" "}
                      -{" "}
                      {moment(main_contract_end_date, "YYYY-MM-DD").format(
                        "DD/MM/YYYY",
                      )}
                    </span>
                    {/* check if shiftDate is pastDate from today of not */}
                    {moment(shiftDate).isAfter(moment()) ? (
                      <span className="grid h-[23px] w-[85px] place-items-center rounded border border-red bg-red-200 text-[12px] font-medium text-red">
                        {getTodayDiff(shiftDate)}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          } else if (contract_status == "Applied") {
            return (
              <div className="overflow-hidden font-openSans" key={index}>
                <div className="flex max-w-full gap-3 px-[12px] py-[8px]">
                  <div className="flex flex-col gap-[3px]">
                    <h4 className="line-clamp-1 text-[14px] font-semibold leading-[20px] text-black">
                      {role_name}
                    </h4>
                    {!clientUserAllPermissions ||
                    clientUserAllPermissions.is_allow_to_view_contract_detail ===
                      1 ? (
                      <>
                        <Link
                          to={routingConstants.contractDetail(
                            route_contract_id,
                          )}
                          className="text-[12px] font-medium leading-[normal] text-green"
                          target="_blank"
                        >
                          {main_contract_ref_no}
                        </Link>
                      </>
                    ) : (
                      <span className="cursor-default text-[12px] font-medium leading-[normal] text-red">
                        {main_contract_ref_no}
                      </span>
                    )}
                    {/* <Link to={routingConstants.contractDetail(route_contract_id)} className="text-[12px] text-txtColor font-medium leading-[normal]">
                      {main_contract_ref_no}
                    </Link> */}
                    <span className="text-[12px] font-medium leading-[normal] text-txtColor">
                      {moment(main_contract_start_date, "YYYY-MM-DD").format(
                        "DD/MM/YYYY",
                      )}{" "}
                      -{" "}
                      {moment(main_contract_end_date, "YYYY-MM-DD").format(
                        "DD/MM/YYYY",
                      )}
                    </span>
                  </div>
                </div>
              </div>
            );
          } else if (
            contract_status == "Booked" ||
            contract_status == "Worked"
          ) {
            return (
              <div className="overflow-hidden font-openSans" key={index}>
                <div className="flex max-w-full gap-3 px-[12px] py-[8px]">
                  <div>
                    <Avatar
                      alt={candidate_name}
                      sx={{ width: 45, height: 45 }}
                      src={profile_image ? profile_image : ""}
                    />
                  </div>
                  <div className="flex grow flex-col gap-[3px] overflow-hidden">
                    {(!clientUserAllPermissions ||
                      clientUserAllPermissions.is_allow_to_view_candidate_profile ===
                        1) &&
                    is_past_booking ? (
                      <>
                        <Link
                          to={routingConstants.candidateDetail(route_id)}
                          className="line-clamp-1 text-[14px] font-semibold leading-[20px] text-black"
                        >
                          {candidate_name}
                        </Link>
                      </>
                    ) : (
                      <span className="line-clamp-1 cursor-default text-[14px] font-semibold leading-[20px] text-black">
                        {candidate_name}
                      </span>
                    )}
                    {/* <Link to={routingConstants.candidateDetail(route_id)} className="font-semibold text-[14px] leading-[20px] text-black line-clamp-1">
                      {candidate_name}
                    </Link> */}
                    {(!clientUserAllPermissions ||
                      clientUserAllPermissions.is_allow_to_view_contract_detail ===
                        1) &&
                    is_past_booking ? (
                      <>
                        <Link
                          to={routingConstants.contractDetail(
                            route_contract_id,
                          )}
                          className="text-[12px] font-medium leading-[normal] text-txtColor"
                        >
                          {main_contract_ref_no}
                        </Link>
                      </>
                    ) : (
                      <span className="cursor-default text-[12px] font-medium leading-[normal] text-txtColor">
                        {main_contract_ref_no}
                      </span>
                    )}
                    {/* <Link to={routingConstants.contractDetail(route_contract_id)} className="text-[12px] text-txtColor font-medium leading-[normal]">
                      {main_contract_ref_no}
                    </Link> */}
                    <Progress
                      percent={profile_percent}
                      size="small"
                      strokeColor={getProgressColor(profile_percent)}
                      format={(percentage) => {
                        return (
                          <span className="d-inline max-w-full font-openSans text-[12px] font-semibold leading-[normal]">
                            {percentage}%
                          </span>
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          }
        })}
      </Carousel>
    </div>
  );
};
